import axios from 'axios';
import {
  defaultRequestResolve,
  defaultRequestReject,
  defaultResponseResolve,
  defaultResponseReject,
} from './interceptors';

const baseReq = axios.create({
  timeout: 8000
});

baseReq
  .interceptors
  .request
  .use(defaultRequestResolve, defaultRequestReject);

baseReq
  .interceptors
  .response
  .use(defaultResponseResolve, defaultResponseReject);


const STAT_API = '//pv.kuaizhan.com/portrait/apiv1/stat'

/**
 * 发送统计
 */
function portraitFetch ({
  category,
  action = 'enter',
  page = 'workspace',
  bizType,
  bizId
}: {
  category?: string,              // 事件类别，标明是谁，如注册button，用户下单 (**非必须**)
  action?: 'click' | 'enter',     // 事件操作，标明做了什么，比如点击，曝光 (必须 click、enter)
  page?: string,                  // 标识是哪个页面
  bizId?: string                  // 业务id (ex: 公众号业务是weixinAppId 建站 站点id) (**非必须**)
  bizType: number // 业务类型 (ex: 公众号 1 | 站点 2 | 快客多 3 | 投票 4 | 畅言云评 5  | 小程序 6)
}
) {
  return baseReq.get(STAT_API, {
    params: {
      category: category || '',
      action: action || 'click',
      page: page || 'workspace',
      bizType: bizType
    }
  })
}

const APIs = {
  portraitFetch
}

export default APIs;